import { Tape } from "../atoms/Tape.tsx";
import { SearchBar } from "./SearchBar.tsx";

export function SectionHead({ title, sub }: { title: string; sub: string }) {
  return (
    <>
      <div className="section-head">
        <h2>
          <Tape />
          {title}
        </h2>
      </div>
      <p className="section-sub">{sub}</p>
      <SearchBar className="search-bar--section" />
    </>
  );
}
